import { DialogActions, Dialog, DialogContent, DialogTitle, Button } from '@material-ui/core'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
class EditOrderBooking extends Component {
  state = {
    isLoading: false,
    comments: '',
    statusId: '',
    is_paydo_store: false,
  }

  componentDidMount = () => {
    this.setState({
      is_paydo_store: this.props.orderData?.store_orders?.find((ele) => ele.store?.is_paydo_store),
    })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  render() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={'sm'}
        open={this.props.openDailog}
        onClose={this.props.handleClose}
      >
        <DialogTitle>Edit Bookings</DialogTitle>
        <DialogContent>
          <div
            className="form-group col"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <label className="col-sm-5 col-form-label">Status</label>
            <select
              className="form-control col-md-7"
              onChange={this.handleChange}
              value={this.state.statusId}
              required
              name="statusId"
            >
              <option
                value={''}
                key={''}
              >
                Select Status
              </option>
              {this.props.statusList.map((item) => (
                <option
                  key={item.id}
                  value={item.id}
                >
                  {item.name_en + ' / ' + item.name_ar}
                </option>
              ))}
            </select>
          </div>

          {this.state.is_paydo_store && (
            <div
              className="form-group col"
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'left',
              }}
            >
              <div style={{ color: 'red' }}>
                To cancel store items order, Need to contact with <b>Paydo Team</b>
              </div>
            </div>
          )}

          <div
            className="form-group col"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <label className="col-sm-5 col-form-label">Comments</label>
            <textarea
              type="text"
              className="form-control col-md-7"
              name="comments"
              placeholder="Comments"
              onChange={this.handleChange}
              value={this.state.comments}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <div className="row float-right p-3">
            <Link
              className="btn btn-outline-dark mr-2"
              onClick={this.props.handleClose}
            >
              Close
            </Link>
            <Button
              className="btn btn-grd-disabled mr-2"
              onClick={() =>
                this.props.handleUpdate({
                  comment: this.state.comments,
                  statusId: this.state.statusId,
                  bookingId: this.props.bookingId,
                })
              }
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? 'Updating...' : 'Update'}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    )
  }
}
export default EditOrderBooking
